const FileIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12.488} height={16} {...props}>
    <g data-name="Group 5104">
      <path
        fill="#00c4de"
        d="M0 0v16h12.488V3.9H8.976a.405.405 0 0 1-.39-.39V0Zm9.366.39v2.732h2.732Zm-7.22 2.537h3.9a.39.39 0 1 1 0 .781h-3.9a.39.39 0 0 1 0-.781Zm0 3.122h8.194a.39.39 0 0 1 0 .781H2.145a.39.39 0 0 1 0-.781Zm0 3.122h8.194a.39.39 0 0 1 0 .781H2.145a.39.39 0 0 1 0-.781Zm0 3.122h8.194a.39.39 0 1 1 0 .781H2.145a.39.39 0 0 1 0-.781Z"
        data-name="download (9)"
      />
    </g>
  </svg>
);

export default FileIcon;
